/**
 * Auth Module
 */
export const SET_USER = "SET_USER";
export const SET_ORGANISATION = "SET_ORGANISATION";
export const SET_ORGANISATIONS = "SET_ORGANISATIONS";
export const SET_WALLET = "SET_WALLET";
export const SET_SWITCH_KEY = "SET_SWITCH_KEY";
export const LOGOUT = "LOGOUT";

/**
 * AuthX Module
 */
export const SET_AUTHX_APP = "SET_AUTHX_APP";
